import { moduleProviderFactory } from 'core/providers';
import { EmailTemplatesEdit, EmailTemplatesList } from 'application/email-templates/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.email-templates',
                pattern: '/email-templates',
                children: [
                    {
                        name: 'master.app.main.email-templates.list',
                        pattern: '',
                        tabTitle: 'EMAIL_TEMPLATES.LIST.TITLE_SECONDARY',
                        component: EmailTemplatesList,
                        data: {
                            title: 'EMAIL_TEMPLATES.LIST.TITLE_SECONDARY'
                        }
                    },
                   {
                        name: 'master.app.main.email-templates.create',
                        pattern: '/create',
                        tabTitle: 'Create Email Template',
                        component: EmailTemplatesEdit,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'EMAIL_TEMPLATES.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.email-templates.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'Edit Email Template',
                        component: EmailTemplatesEdit,
                        authorization: 'portalSection.update',
                        data: {
                            title: 'EMAIL_TEMPLATES.EDIT.TITLE'
                        },
                    }                 
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.MASTER_DATA',
                order: 6,
                icon: 'database',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.EMAIL_TEMPLATES_SUB',
                        route: 'master.app.main.email-templates.list',
                        order: 5,
                    }                    
                ]
            }
        ]
    });
})();
